import React, { useEffect, useState } from 'react'
import faq from "../../Assets/faq.png"
import './contact.styles.scss'
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Button } from '@mui/material'
import { useTranslation } from 'react-i18next';
import emailjs from "@emailjs/browser";
import config from '../../config';
import { useNavigate } from 'react-router';
import ReCAPTCHA from 'react-google-recaptcha';
import { Helmet } from 'react-helmet-async';

const Contact = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [emailError, setEmailError] = useState(false);
    const [isValid, setIsValid] = useState(false);
    const [isRecaptchaOk, setIsRecaptchaOk] = useState(false);
    const [form, setForm] = useState({
        name: null,
        email: null,
        self: false,
        inventory: false,
        ecommerce: false,
        fidelity: false,
        project: null,
        policy: false,
        marketing: false,
    });

    useEffect(() => {
        emailjs.init(config.apiKey)
    }, []);

    const sx = {
        '&.Mui-checked': {
            color: '#7ab529',
        }
    }

    const onSubmit = (data) => {
        data.preventDefault();
        console.log(form);
        let from_topic = "";
        if (form.self) from_topic = from_topic + "SELF-SCANNING;";
        if (form.inventory) from_topic = from_topic + "INVENTARIO;";
        if (form.ecommerce) from_topic = from_topic + "ECOMMERCE;";
        if (form.fidelity) from_topic = from_topic + "FIDELITY E COUPONING;";
        let body = {
            from_name: form.name,
            from_email: form.email,
            from_topic: from_topic,
            from_project: form.project,
        }
        emailjs.send(config.emailService, config.emailTemplate, body)
            .then(response => {
                navigate("/thanks")
            })
            .catch(error => console.log(error))
    }

    const onChange = (e) => {
        if (e.target.name === "email") {
            if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(e.target.value)) {
                setEmailError(true);
            } else {
                setEmailError(false);
            }
        }
        setForm({
            ...form, [e.target.name]:
                e.target.name === "name" || e.target.name === "email" || e.target.name === "project" ? e.target.value : e.target.checked
        })
    }

    useEffect(() => {
        if (
            /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(form.email)
            && (form.name !== "" && form.name !== null)
            && (form.project !== "" && form.project !== null)
            && form.policy
        ) {
            setIsValid(true);
        } else {
            setIsValid(false);
        }
    }, [form])



    return (
        <div className='contact'>
            <Helmet>
                <meta itemProp="name" content="Chi siamo" />
                <meta itemProp="description" content="Inizia il tuo progetto facciamo accadere le cose" />
            </Helmet>
            <div className='banner'>
                <div className='titleContainer'>
                    <label className='subtitle' aria-label={t("contact.subtitle")}>{t("contact.subtitle")}</label>
                    <label className='title' aria-label={t("contact.title")}>{t("contact.title")}</label>
                </div>
                <img src={faq} alt="FAQ" aria-label="FAQ" />
            </div>
            <div className='form'>
                <label className='title' aria-label={t("contact.title")}>{t("contact.title")}</label>
                <form onSubmit={onSubmit} noValidate>
                    <label htmlFor='name'>{t("nameSurname")}</label>
                    <input
                        className='custom-input'
                        id='name'
                        name='name'
                        type='text'
                        placeholder='Mario Rossi'
                        aria-label={t("nameSurname")}
                        onChange={onChange}
                        value={form.name}
                    />
                    <label htmlFor='email'>{t("email")}</label>
                    <input
                        className='custom-input'
                        id='email'
                        name='email'
                        type='email'
                        placeholder='Email@email.com'
                        aria-label={t("email")}
                        onChange={onChange}
                        value={form.email}
                    />
                    {emailError && <small style={{ color: '#E7475E' }} aria-live="assertive">{t("error.email")}</small>}
                    <FormGroup style={{ margin: "20px 0", maxWidth: '720px' }}>
                        <label aria-label={t("contact.selectOptions")}>{t("contact.selectOptions")}</label>
                        <small aria-label={t("contact.selectSubtitle")}>{t("contact.selectSubtitle")}</small>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    id='self'
                                    name='self'
                                    sx={sx}
                                    onChange={onChange}
                                    value={form.self}
                                    inputProps={{ 'aria-label': t("footer.selfscanning") }}
                                />
                            }
                            label={t("footer.selfscanning")}
                        />
                        <small>{t("contact.check1")}</small>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    id='ecommerce'
                                    name='ecommerce'
                                    sx={sx}
                                    onChange={onChange}
                                    value={form.ecommerce}
                                    inputProps={{ 'aria-label': t("footer.ecommerce") }}
                                />
                            }
                            label={t("footer.ecommerce")}
                        />
                        <small>{t("contact.check2")}</small>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    id='inventory'
                                    name='inventory'
                                    sx={sx}
                                    onChange={onChange}
                                    value={form.inventory}
                                    inputProps={{ 'aria-label': t("footer.inventory") }}
                                />
                            }
                            label={t("footer.inventory")}
                        />
                        <small>{t("contact.check3")}</small>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    id='fidelity'
                                    name='fidelity'
                                    sx={sx}
                                    onChange={onChange}
                                    value={form.fidelity}
                                    inputProps={{ 'aria-label': t("footer.fidelity") }}
                                />
                            }
                            label={t("footer.fidelity")}
                        />
                        <small>{t("contact.check4")}</small>
                    </FormGroup>
                    <label htmlFor='project'>{t("contact.project")}</label>
                    <textarea
                        id='project'
                        name='project'
                        placeholder={t("contact.project")}
                        rows={10}
                        className='custom-input'
                        aria-label={t("contact.project")}
                        onChange={onChange}
                        value={form.project}
                    />
                    <FormGroup style={{ margin: "20px 0", maxWidth: '720px' }}>
                        <FormControlLabel
                            required
                            control={
                                <Checkbox
                                    id='policy'
                                    name='policy'
                                    sx={sx}
                                    onChange={onChange}
                                    value={form.policy}
                                    inputProps={{ 'aria-label': t("policy") }}
                                />
                            }
                            label={t("policy")}
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    id='marketing'
                                    name='marketing'
                                    sx={sx}
                                    onChange={onChange}
                                    value={form.marketing}
                                    inputProps={{ 'aria-label': t("marketing") }}
                                />
                            }
                            label={t("marketing")}
                        />
                    </FormGroup>
                    <div aria-label="reCAPTCHA">
                        <ReCAPTCHA
                            sitekey={config.RECAPTCHA_API_KEY}
                            onChange={() => setIsRecaptchaOk(true)}
                            onExpired={() => setIsRecaptchaOk(false)}
                        />
                    </div>
                    <Button
                        type='submit'
                        variant="contained"
                        style={{ backgroundColor: '#416D03' }}
                        disabled={!isValid && !isRecaptchaOk}
                        aria-label={t("sendRequest")}
                    >
                        {t("sendRequest")}
                    </Button>
                </form>
            </div>
        </div>
    )
}

export default Contact